import { HttpContext, HttpContextToken } from "@angular/common/http";

export const SKIP_AUTH = new HttpContextToken<void>(() => undefined);

export function withSkipAuth(context: HttpContext = new HttpContext()) {
  return context.set(SKIP_AUTH, undefined);
}
